import Vue from 'vue'
import Alert from 'element-ui/lib/alert'
import Aside from 'element-ui/lib/aside'
import Autocomplete from 'element-ui/lib/autocomplete'
import Button from 'element-ui/lib/button'
import Card from 'element-ui/lib/card'
import Cascader from 'element-ui/lib/cascader'
import Checkbox from 'element-ui/lib/checkbox'
import CheckboxButton from 'element-ui/lib/checkbox-button'
import CheckboxGroup from 'element-ui/lib/checkbox-group'
import Col from 'element-ui/lib/col'
import Collapse from 'element-ui/lib/collapse'
import CollapseItem from 'element-ui/lib/collapse-item'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import ColorPicker from 'element-ui/lib/color-picker'
import Container from 'element-ui/lib/container'
import DatePicker from 'element-ui/lib/date-picker'
import Descriptions from 'element-ui/lib/descriptions'
import DescriptionsItem from 'element-ui/lib/descriptions-item'
import Dialog from 'element-ui/lib/dialog'
import Divider from 'element-ui/lib/divider'
import Drawer from 'element-ui/lib/drawer'
import Dropdown from 'element-ui/lib/dropdown'
import DropdownItem from 'element-ui/lib/dropdown-item'
import DropdownMenu from 'element-ui/lib/dropdown-menu'
import Empty from 'element-ui/lib/empty'
import Form from 'element-ui/lib/form'
import FormItem from 'element-ui/lib/form-item'
import Header from 'element-ui/lib/header'
import Image from 'element-ui/lib/image'
import Input from 'element-ui/lib/input'
import InputNumber from 'element-ui/lib/input-number'
import Link from 'element-ui/lib/link'
import Loading from 'element-ui/lib/loading'
import Main from 'element-ui/lib/main'
import Menu from 'element-ui/lib/menu'
import MenuItem from 'element-ui/lib/menu-item'
import Message from 'element-ui/lib/message'
import MessageBox from 'element-ui/lib/message-box'
import Notification from 'element-ui/lib/notification'
import Option from 'element-ui/lib/option'
import OptionGroup from 'element-ui/lib/option-group'
import Pagination from 'element-ui/lib/pagination'
import Popover from 'element-ui/lib/popover'
import Progress from 'element-ui/lib/progress'
import Radio from 'element-ui/lib/radio'
import RadioButton from 'element-ui/lib/radio-button'
import RadioGroup from 'element-ui/lib/radio-group'
import Row from 'element-ui/lib/row'
import Select from 'element-ui/lib/select'
import Skeleton from 'element-ui/lib/skeleton'
import Slider from 'element-ui/lib/slider'
import Submenu from 'element-ui/lib/submenu'
import Switch from 'element-ui/lib/switch'
import TabPane from 'element-ui/lib/tab-pane'
import Table from 'element-ui/lib/table'
import TableColumn from 'element-ui/lib/table-column'
import Tabs from 'element-ui/lib/tabs'
import Tag from 'element-ui/lib/tag'
import TimeSelect from 'element-ui/lib/time-select'
import TimePicker from 'element-ui/lib/time-picker'
import Timeline from 'element-ui/lib/timeline'
import TimelineItem from 'element-ui/lib/timeline-item'
import Tooltip from 'element-ui/lib/tooltip'
import Upload from 'element-ui/lib/upload'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles.css'
import { formatBeijingDateTime } from './utils/time'

Vue.config.productionTip = false
const elementComponents = [
  Alert, Aside, Autocomplete, Button, Card, Cascader, Checkbox, CheckboxButton, CheckboxGroup,
  Col, Collapse, CollapseItem, ColorPicker, Container, DatePicker, Descriptions,
  DescriptionsItem, Dialog, Divider, Drawer, Dropdown, DropdownItem, DropdownMenu,
  Empty, Form, FormItem, Header, Image, Input, InputNumber, Link, Main, Menu,
  MenuItem, Option, OptionGroup, Pagination, Popover, Progress, Radio, RadioButton,
  RadioGroup, Row, Select, Skeleton, Slider, Submenu, Switch, TabPane, Table,
  TableColumn, Tabs, Tag, TimeSelect, TimePicker, Timeline, TimelineItem, Tooltip, Upload
]
elementComponents.forEach(component => Vue.use(component))
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.filter('beijingDateTime', formatBeijingDateTime)
Vue.prototype.$formatBeijingDateTime = formatBeijingDateTime

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
